import { render, staticRenderFns } from "./BillingReportTable.vue?vue&type=template&id=c252ff52&"
import script from "./BillingReportTable.vue?vue&type=script&lang=js&"
export * from "./BillingReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports